import React from 'react';
import { withProperties } from '$/utils/type';

import Button, {
  Cancel,
  Rounded,
  Primary,
  Bordered,
  IconButton,
  BoxButton,
  RowButton,
  ButtonProps,
} from './Button';

import Analytics from './Analytics';
import RedText from './RedText';
import Submit from './Submit';
import tw from 'twin.macro';
import { DeleteIcon } from '$/images/Icons';
import { useThemeContext } from '../ThemeContext';

const deleteButton: React.FC<{
  className?: string;
  onClick?: React.MouseEventHandler<Element>;
  rounded?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}> = ({ className, rounded, disabled, onClick, children }) => {
  return (
    <Button
      className={`
        ${rounded && 'bg-color-delete rounded-full hover:shadow-md'}
        ${className}
      `}
      disabled={disabled}
      css={tw`w-1_75e h-1_75e px-2 text-md flex justify-end items-center`}
      onClick={onClick}
    >
      <DeleteIcon className={rounded && 'text-white'} />
      {children}
    </Button>
  );
};

export const BlueText: React.FC<ButtonProps> = ({ children, ...props }) => {
  const etheme = useThemeContext();

  return (
    <Button theme={etheme.controls.button.link} {...props}>
      {children}
    </Button>
  );
};

export default withProperties(Button, {
  cancel: Cancel,
  icon: IconButton,
  box: BoxButton,
  row: RowButton,
  analytics: Analytics,
  blueText: BlueText,
  redText: RedText,
  rounded: Rounded,
  bordered: Bordered,
  primary: Primary,
  submit: Submit,
  delete: deleteButton,
});
